var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:_vm.b({ sortable: _vm.isSortable, active: _vm.active }),on:{"click":_vm.onClick}},[_c('div',{class:_vm.b('container')},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),(_vm.isSortable)?_c('v-icon',{class:_vm.b('icon')},[_vm._v(_vm._s(_vm.iconName))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }